import { render } from "./MuttonMainCourse.vue?vue&type=template&id=0b135a8e"
import script from "./MuttonMainCourse.vue?vue&type=script&lang=js"
export * from "./MuttonMainCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__